module.exports = new __parcel__URL__("open_all_button.cd8630bf.png").toString();